﻿// NG 2
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

// app
import { AuthenticationService } from '../../services/authentication.service';
import { SharedService } from '../../services/shared.service';
@Component({
    selector: 'app-logout',
    templateUrl: './logout.component.html',
})
export class LogoutComponent implements OnInit {

    model: any = {};
    loading = false;
    isUrlIncludeSession: boolean = false; 
    returnUrl: string = "./#/login";
    returnUrlSession: string = "./#/login?session=0";

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private authenticationService: AuthenticationService, 
        private sharedService: SharedService
    ) { }

    ngOnInit() {

        this.isUrlIncludeSession = this.router.url.toLowerCase().includes('session=0');
        this.logout();  
    }  

    logout() {
        this.sharedService.removeData('loggedInUser');
        if (this.isUrlIncludeSession)
            this.router.navigate([this.returnUrlSession]);
        else 
            this.router.navigate([this.returnUrl]);

    }



}